export default {
  serverURI: '/api',
  menu: [
    {title: 'หน้าหลัก', path: '/', icon: 'dashboard'}
  ]
}



// WEBPACK FOOTER //
// ./src/config/index.js